// extracted by mini-css-extract-plugin
export default {"container":"d7Nj0","hiddenBalance":"FVOg5","hiddenBalanceValue":"C5u77","accentIcon":"nDefK"};